import type { ProductType } from "@/api_client";
import { matchProductType } from "@/utils/productUtils";

import { capitalizeFirstLetter } from "./capitalize";

export const getProductName = (
  productType: ProductType | undefined,
): string => {
  if (!productType) {
    return "";
  }
  const name = capitalizeFirstLetter(productType);
  return matchProductType(productType, {
    travel: name,
    householder: "Home",
    baby: name,
    car: name,
    income: name,
    sport: name,
    child: name,
    cat: name,
    dog: name,
    van: name,
    camper: name,
    "": "",
  });
};
